import service from '@/store/services/vendors/guidance-labourers-service';

const state = {
    list: {},
    guidanceLabourer: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, guidanceLabourer) => {
        state.guidanceLabourer = guidanceLabourer;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(guidanceLabourer => {
                commit('SET_RESOURCE', guidanceLabourer);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(guidanceLabourer => {
                commit('SET_RESOURCE', guidanceLabourer);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((guidanceLabourer) => {
                commit('SET_RESOURCE', guidanceLabourer);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((guidanceLabourer) => {
                commit('SET_RESOURCE', guidanceLabourer);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    guidanceLabourer: state => state.guidanceLabourer,
    dropdown: (state) => {
        return state.list.map(guidanceLabourer => ({
            id: guidanceLabourer.id,
        }));
    }
};

const guidanceLabourers = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default guidanceLabourers;
